import { FirestoreDataConverter } from "firebase/firestore";
import moment from "moment";
import {
  DebitoCredito,
  MoedaInternacional,
  TipoOperacaoInternacional,
} from "../models/enum";
import OperacaoInternacional, {
  OperacaoLeitorInternacional,
} from "../models/operacaoInternacional";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class OperacaoInternacionalDb extends BaseDb<
  OperacaoInternacional | OperacaoLeitorInternacional,
  { usuarioId: string; operacaoInternacionalId: string }
> {
  _path: string =
    "usuarios/usuarioId/operacoesInternacionais/operacaoInternacionalId";

  getConverter(): FirestoreDataConverter<
    OperacaoInternacional | OperacaoLeitorInternacional
  > {
    return {
      fromFirestore: (snapshot) => {
        // Detecta se a operação já foi enriquecida verificando se existe o campo tipoOperacao
        const isEnriquecida = snapshot.get("tipoOperacao") !== undefined;

        if (isEnriquecida) {
          return new OperacaoInternacional({
            id: snapshot.id,
            dataPregao: moment(snapshot.get("dataPregao").toDate()),
            descricao: snapshot.get("descricao"),
            valorOperacao: snapshot.get("valorOperacao"),
            debitoCredito: snapshot.get("debitoCredito") as DebitoCredito,
            moeda: snapshot.get("moeda") as MoedaInternacional,
            uploadId: snapshot.get("uploadId"),
            instituicao: snapshot.get("instituicao"),
            quantidade: snapshot.get("quantidade"),
            tipoOperacao: snapshot.get(
              "tipoOperacao"
            ) as TipoOperacaoInternacional,
            ativo: snapshot.get("ativo"),
            valorOperacaoBRL: snapshot.get("valorOperacaoBRL"),
            fator: snapshot.get("fator"),
            evento: snapshot.get("evento"),
            codigoNovo: snapshot.get("codigoNovo"),
            manual: snapshot.get("manual"),
            duplicataDeUploadId: snapshot.get("duplicataDeUploadId"),
            liquidacao: snapshot.get("liquidacao"),
            multiplicador: snapshot.get("multiplicador"),
          });
        }

        // Caso contrário, retorna a versão do leitor (sem enrich)
        return new OperacaoLeitorInternacional({
          id: snapshot.id,
          dataPregao: moment(snapshot.get("dataPregao").toDate()),
          descricao: snapshot.get("descricao"),
          valorOperacao: snapshot.get("valorOperacao"),
          debitoCredito: snapshot.get("debitoCredito") as DebitoCredito,
          moeda: snapshot.get("moeda") as MoedaInternacional,
          uploadId: snapshot.get("uploadId"),
          instituicao: snapshot.get("instituicao"),
          quantidade: snapshot.get("quantidade"),
          ativo: snapshot.get("ativo"),
          liquidacao: snapshot.get("liquidacao"),
          multiplicador: snapshot.get("multiplicador"),
        });
      },
      toFirestore: toFirestore,
    };
  }
}
